import React from 'react';
import './Food.css';
import FMSimage from '../Assets/food.jpg'; // First image (full size)
import FMSimage2 from '../Assets/food1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/food2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/food4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/food3.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">FOOD CHAIN INDUSTRY</h1>
                    <p className="FMS-description">

                    The Food Chain Management System (FCMS) from Vajra IoT is a comprehensive solution designed to monitor and manage the entire food supply chain. It ensures traceability, quality control, and operational efficiency across all stages of food production, storage, and distribution. By providing real-time insights into temperature, humidity, and stock levels, this system helps prevent spoilage, ensures food safety, and optimizes the supply chain for better profitability and sustainability.





</p>                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Real-Time Monitoring:</strong> Monitor the entire food supply chain in real-time, from production to delivery, ensuring product quality and freshness.</li>
    <li><strong>Traceability:</strong> Track the origin and journey of food products, ensuring transparency and compliance with safety standards.</li>
    <li><strong>Inventory Management:</strong> Efficiently manage inventory levels and ensure timely restocking to prevent shortages or waste.</li>
    <li><strong>Temperature Control:</strong> Continuously monitor and control temperatures in transportation and storage to ensure food safety.</li>
    <li><strong>Supply Chain Optimization:</strong> Optimize routes, delivery times, and supplier coordination for cost-effective operations and on-time deliveries.</li>
</ul>



                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
  <li><strong>Centralized Monitoring:</strong> A web-based control system manages the entire food supply chain, providing real-time monitoring of inventory, production, and delivery statuses.</li>
  <li><strong>Automated Control:</strong> Production lines, packaging, and inventory systems are controlled remotely to streamline operations and ensure timely processing.</li>
  <li><strong>Traceability & Alerts:</strong> The system tracks the origin and movement of food products, sending alerts for any deviations in quality or compliance.</li>
  <li><strong>Temperature & Humidity Control:</strong> Sensors monitor and regulate temperatures and humidity levels throughout the supply chain to ensure the safety and freshness of food products.</li>
  <li><strong>Supply Chain Optimization:</strong> The system analyzes routes, delivery schedules, and supplier coordination, ensuring timely and cost-effective deliveries while minimizing waste.</li>
</ul>



                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Food Chain Industry</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Improved Food Supply Chain Management:</strong> Real-time monitoring ensures efficient product flow, timely deliveries, and optimized supply chain operations.</li>
    <li><strong>Enhanced Product Quality Control:</strong> Continuous monitoring of temperature, humidity, and quality parameters ensures safe and fresh food products throughout the supply chain.</li>
    <li><strong>Cost Savings:</strong> By tracking inventory, optimizing production processes, and reducing waste, the system helps lower operational costs and improve overall efficiency.</li>
    <li><strong>Ease of Use:</strong> The user-friendly, web-based platform simplifies management, reporting, and monitoring, making it easy to access from anywhere.</li>
</ul>



                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            {/* New Section: Industries Using Our FMS */}
<div className="FMS-bottom-heading">
    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
</div>

<div className="FMS-content-container reverse-order-last">
    {/* Left side: Image for Industries */}
    <div className="FMS-image-container">
        <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
    </div>

    {/* Right side: Text Content */}
    <div className="FMS-text">
        <p className="FMS-description">
        <p className="FMS-description">
    Our Food Chain Industry Management System is trusted by various sectors to optimize supply chain management, enhance product quality, and reduce operational costs. These industries rely on our solution for its precision, reliability, and cost-saving benefits:
    <ul>
        <li>Food Processing</li>
        <li>Cold Chain Logistics</li>
        <li>Retail & Distribution</li>
        <li>Food Storage & Warehousing</li>
        <li>Restaurants & Catering Services</li>
    </ul>
</p>

</p>
    </div>
</div>

        </div>
    );
};

export default FMS;
